// src/utils/pdfDownload.js — docpdf-8a4c1e73 (2026-10-28)
//
// Every PDF the app downloads now arrives as BYTES from the server (pdfBase64 + fileName): invoices,
// estimates and credit notes (staff and the customer portal), checklist copies, and the private copies of
// emailed PDFs. Nothing is stored on the server and there is no link: the file exists only in this
// browser. (Before, invoice / estimate / credit-note PDFs were saved in Storage and opened through a link
// that worked for anyone for up to 7 days.)
//
// Moved here from utils/checklistClient.js (custcopy-32471cbd), which re-exports it unchanged.

const toBlobUrl = (pdfBase64) => {
    if (!pdfBase64) throw new Error('Could not make the PDF. Please try again.');
    const bin = atob(pdfBase64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
};

// Save the PDF as a file (a.download). The temporary in-browser address is released after a minute.
export const downloadPdfBytes = (pdfBase64, fileName) => {
    const url = toBlobUrl(pdfBase64);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'Document.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
};

// Open the browser's print dialog for the PDF (estimate "Print"). The bytes are loaded into a hidden frame
// on this page (an in-browser address, so the print is allowed in every browser — the old Storage link was
// cross-site and Safari / Firefox could block it). If printing can't start, the PDF is saved instead.
export const printPdfBytes = (pdfBase64, fileName) => {
    const url = toBlobUrl(pdfBase64);
    const iframe = document.createElement('iframe');
    Object.assign(iframe.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' });
    let settled = false;
    const fallback = () => {
        if (settled) return;
        settled = true;
        try { iframe.remove(); } catch (_) { /* already gone */ }
        URL.revokeObjectURL(url);
        downloadPdfBytes(pdfBase64, fileName);
    };
    const timeoutId = setTimeout(fallback, 4000);
    iframe.onload = () => {
        try {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            settled = true;
            clearTimeout(timeoutId);
            setTimeout(() => { try { iframe.remove(); } catch (_) { /* gone */ } URL.revokeObjectURL(url); }, 60000);
        } catch (err) {
            clearTimeout(timeoutId);
            fallback();
        }
    };
    iframe.src = url;
    document.body.appendChild(iframe);
};
